module.exports = __webpack_public_path__ + "static/media/calendarimage.a42a8388.svg";